import { SOCIAL_AD_TYPES } from "utils/constants";
import { MEGA, SECONDS_PER_MIN } from "utils/common";

import { isURL, maxLength, requiredNotNull } from "widgets/forms/validators/validators";
import { creativeNameAllowedChars, creativeNameMaxLength } from "widgets/forms/validators/Creatives";
import { filesize, duration, exactDimensions } from "widgets/forms/validators/Assets";
import {
	errorMessageReducer,
	makeDynamicConfig,
	requiredAsset,
	validateUnlessAdStudio
} from "./validators";
import { mergeLists, uniqueVariableName } from "social/validators/utils";


/**
 * Snapchat Image
 ********************************************/

export const SNAPCHAT_IMAGE_CONSTRAINTS = {
	MAX_LENGTH_HEADLINE: 34,
	MAX_LENGTH_BRAND_NAME: 25,
	MAX_LENGTH_LANDING_PAGE: 800,
	MAX_IMAGE_MB: 5,
	IMAGE_ACCEPT: ".jpg, .jpeg, .png",
	DIMENSIONS: {
		width: 1080,
		height: 1920,
	},
};

export const SNAPCHAT_IMAGE_VALIDATORS = {
	image: validateUnlessAdStudio([
		requiredAsset,
		filesize({
			max: SNAPCHAT_IMAGE_CONSTRAINTS.MAX_IMAGE_MB * MEGA,
		}),
		exactDimensions(SNAPCHAT_IMAGE_CONSTRAINTS.DIMENSIONS),
	]),
	headline: [
		requiredNotNull,
		maxLength(SNAPCHAT_IMAGE_CONSTRAINTS.MAX_LENGTH_HEADLINE),
	],
	brandName: [
		maxLength(SNAPCHAT_IMAGE_CONSTRAINTS.MAX_LENGTH_BRAND_NAME),
	],
	landingPage: [
		requiredNotNull,
		isURL,
		maxLength(SNAPCHAT_IMAGE_CONSTRAINTS.MAX_LENGTH_LANDING_PAGE),
	],
	cta: [
		requiredNotNull
	],
};

const SNAPCHAT_IMAGE_WARNINGS = mergeLists(
	{
		image: [uniqueVariableName],
		headline: [uniqueVariableName],
		brandName: [uniqueVariableName],
		landingPage: [uniqueVariableName],
		cta: [uniqueVariableName],
	},
	makeDynamicConfig(SNAPCHAT_IMAGE_VALIDATORS)
);

export function snapchatImageWarning(allValues, props) {
	const formName = SOCIAL_AD_TYPES.SNAPCHAT_IMAGE;
	const values = allValues[formName] || {};

	if(!values.isDynamic){
		return errorMessageReducer(SNAPCHAT_IMAGE_WARNINGS, values, formName);
	}
}

export function snapchatImageValidator(allValues, props) {
	const formName = SOCIAL_AD_TYPES.SNAPCHAT_IMAGE;
	const values = allValues[formName] || {};

	let validators = {
		name: [requiredNotNull, creativeNameMaxLength, creativeNameAllowedChars],
	};

	if(values.isDynamic){
		validators = {
			...validators,
			...SNAPCHAT_IMAGE_WARNINGS,
		};
	}

	return errorMessageReducer(validators, values, formName);
}


/**
 * Snapchat Video
 ********************************************/

export const SNAPCHAT_VIDEO_CONSTRAINTS = {
	MAX_LENGTH_HEADLINE: 34,
	MAX_LENGTH_BRAND_NAME: 25,
	MAX_LENGTH_LANDING_PAGE: 800,
	MIN_VIDEO_SEC: 3,
	MAX_VIDEO_MIN: 3,
	MAX_VIDEO_MB: 512,
	VIDEO_ACCEPT: ".mp4, .mov",
	DIMENSIONS: {
		width: 1080,
		height: 1920,
	},
};

export const SNAPCHAT_VIDEO_VALIDATORS = {
	video: validateUnlessAdStudio([
		requiredAsset,
		filesize({
			max: SNAPCHAT_VIDEO_CONSTRAINTS.MAX_VIDEO_MB * MEGA,
		}),
		duration({
			min: SNAPCHAT_VIDEO_CONSTRAINTS.MIN_VIDEO_SEC,
			max: SNAPCHAT_VIDEO_CONSTRAINTS.MAX_VIDEO_MIN * SECONDS_PER_MIN,
		}),
		exactDimensions(SNAPCHAT_VIDEO_CONSTRAINTS.DIMENSIONS),
	]),
	headline: [
		requiredNotNull,
		maxLength(SNAPCHAT_VIDEO_CONSTRAINTS.MAX_LENGTH_HEADLINE),
	],
	brandName: [
		maxLength(SNAPCHAT_VIDEO_CONSTRAINTS.MAX_LENGTH_BRAND_NAME),
	],
	landingPage: [
		requiredNotNull,
		isURL,
		maxLength(SNAPCHAT_VIDEO_CONSTRAINTS.MAX_LENGTH_LANDING_PAGE),
	],
	cta: [
		requiredNotNull,
	],
};

const SNAPCHAT_VIDEO_WARNINGS = mergeLists(
	{
		video: [uniqueVariableName],
		headline: [uniqueVariableName],
		brandName: [uniqueVariableName],
		landingPage: [uniqueVariableName],
		cta: [uniqueVariableName],
	},
	makeDynamicConfig(SNAPCHAT_VIDEO_VALIDATORS)
);

export function snapchatVideoWarning(allValues, props) {
	const formName = SOCIAL_AD_TYPES.SNAPCHAT_VIDEO;
	const values = allValues[formName] || {};

	if(!values.isDynamic){
		return errorMessageReducer(SNAPCHAT_VIDEO_WARNINGS, values, formName);
	}
}

export function snapchatVideoValidator(allValues, props) {
	const formName = SOCIAL_AD_TYPES.SNAPCHAT_VIDEO;
	const values = allValues[formName] || {};

	let validators = {
		name: [requiredNotNull, creativeNameMaxLength, creativeNameAllowedChars],
	};

	if(values.isDynamic){
		validators = {
			...validators,
			...SNAPCHAT_VIDEO_WARNINGS,
		};
	}

	return errorMessageReducer(validators, values, formName);
}
